import React, { useEffect } from "react";
import { useUserOnboarding } from "../../../Context/UserOnboardingContext";
import FreshStartWizard from "./components/FreshStartWizard";
import ScreeningSessionWizard from "./components/ScreeningSessionWizard";
import "./index.scss";

const UserOnboarding: React.FC = () => {
  const {
    setScreeningSessionId,
    setCtaType,
    setJobDescription,
    reset,
  } = useUserOnboarding();

  // Read sessionStorage synchronously in the render body — not at module level —
  // so the value is always fresh on each mount (module-level constants are cached
  // for the tab lifetime and miss values written after first load).
  const sessionId = sessionStorage.getItem("pending_screening_session_id");
  const hasSession = !!sessionId;

  useEffect(() => {
    // Reset stale context values from any previous onboarding run.
    // The provider lives at app level and survives route changes.
    reset();

    const token = localStorage.getItem("access-token");
    console.log("[UserOnboarding] mount — access-token present:", !!token, "| length:", token?.length ?? 0);
    if (!token) {
      console.warn("[UserOnboarding] ⚠ No access-token — API calls will likely fail with 401/403");
    }

    if (sessionId) {
      setScreeningSessionId(sessionId);
    }

    const storedCtaType = sessionStorage.getItem("screening_cta_type");
    if (storedCtaType) {
      setCtaType(storedCtaType);
    }

    const storedJobDesc = sessionStorage.getItem("screening_job_description");
    if (storedJobDesc) {
      setJobDescription(storedJobDesc);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="user-onboarding">
      {hasSession ? <ScreeningSessionWizard /> : <FreshStartWizard />}
    </div>
  );
};

export default UserOnboarding;
